<template>
  <div class="table-responsive table-bordered">
    <table class="table text-nowrap">
      <thead>
        <tr>
          <th>Start Time</th>
          <th>Stop Time</th>
          <th>Framed IP</th>
          <th>Phone Number</th>
          <th>Duration</th>
          <th>Termination Cause</th>
          <th>Download</th>
          <th>Upload</th>
          <th>Last Updated</th>
          <th>NAS IP</th>
          <th>NAS Port</th>
        </tr>
      </thead>
      <tbody v-if="sessions.length > 0">
        <tr v-for="session in sessions" :key="session.objKey">
          <td class="text-center">{{ session.startTime }}</td>
          <td class="text-center">
            <span v-if="session.stopTime && session.stopTime != '1970-01-01 02:00:00'">{{ session.stopTime }}</span>
            <span class="badge bg-green" v-else>Active</span>
          </td>
          <td>{{ session.framedIpAddress }}</td>
          <td>{{ session.phoneNumber }}</td>
          <td>
            <span>{{ time(session.duration) }}</span>
          </td>
          <td>
            <span v-if="session.terminationCause">{{ session.terminationCause }}</span>
            <span v-else class="badge bg-secondary">None</span>
          </td>
          <td class="text-center">{{ size(session.outBytes) }}</td>
          <td class="text-center">{{ size(session.inBytes) }}</td>
          <td class="text-center">{{ session.lastUpdate }}</td>
          <td>{{ session.nasIpAddress }}</td>
          <td>{{ session.nasPort }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="11">No sessions available</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AxxessLteSessions",
  props: {
    sessions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    size(bytes) {
      if (bytes == null) return "0 KB";
      if (bytes.toString().length > 9) {
        return this.sizeBytesToGb(bytes) + " GB";
      } else if (bytes.toString().length > 6) {
        return this.sizeBytesToMb(bytes) + " MB";
      }
      return this.sizeBytesToKb(bytes) + " KB";
    },
    time(seconds) {
      return moment.duration(seconds, "seconds").humanize();
    },
  },
};
</script>
